'use client'

import { AdvertisingModalShell } from '@/AdvertisingModal/AdvertisingModalShell'
import { tracking } from '@/tracking'
import { DailyDealsSignup } from './DailyDealsSignup'

/** Controlled campaign modal; callers decide when and where it should open. */
export function DailyDealsSignupModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) {
  return (
    <AdvertisingModalShell
      isOpen={isOpen}
      onClose={() => {
        tracking.track('Daily deals modal closed', { placement: 'modal' })
        onClose()
      }}
      ariaLabel="Deal of the Day signup"
      maxWidth="lg"
    >
      <DailyDealsSignup placement="modal" className="border-0" />
    </AdvertisingModalShell>
  )
}
